import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { PaymentSource, PaymentStatus } from '@campaign-portal/namespace/common/enums';
import { Payments } from '@campaign-portal/namespace/entities/payments/specs';

export interface PaymentsEntityConfig<ID = creating | exist> extends Partial<Payments<ID>> {
	id: ID;
}

export class PaymentsEntity<ID = creating | exist> implements Payments<ID> {
	[x: string]: unknown;

	id: ID;
	amount: number;
	status: PaymentStatus;
	partnerId: Id;
	user: string;
	type: PaymentSource;
	cancelledDate?: string;
	comment?: string;
	creationDate?: string | null;

	constructor(config: PaymentsEntityConfig<ID>) {
		this.id = config.id;
		this.partnerId = config.partnerId ?? null;
		this.amount = config.amount ?? 0;
		this.status = config.status ?? PaymentStatus.CONFIRMED;
		this.user = config.user ?? '';
		this.type = config.type ?? PaymentSource.MANUAL;
		this.cancelledDate = config.cancelledDate;
		this.comment = config.comment;
		this.creationDate = config.creationDate;
	}

	isConfirmed(): boolean {
		return this.status === PaymentStatus.CONFIRMED;
	}

	isManual(): boolean {
		return this.type === PaymentSource.MANUAL;
	}

	isIncoming(): boolean {
		return this.amount > 0;
	}

	isOutgoing(): boolean {
		return this.amount < 0;
	}
}
